export interface Feature {
  name: string;
  initialize: () => void;
}

export function bootstrap(features: Feature[]): void {
  for (const feature of features) {
    try {
      feature.initialize();
    } catch (error) {
      console.error(`[portfolio] Failed to initialize ${feature.name}.`, error);
    }
  }
}
